import { useEffect, useState } from "react";
import { getSync } from "../helpers/api_helper";

export default function useCurrenciesBrandSettings() {
  const [currenciesBrandSettings, setCurrenciesBrandSettings] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const url = "/site/settings";
      try {
        const result = await getSync(url, {});
        setCurrenciesBrandSettings(result?.data?.settings?.financial?.currencies || []);
      } catch (e) {
        console.error("Error calling /settings");
        setCurrenciesBrandSettings([]);
      }
    };

    fetchData();
  }, []);

  return { currenciesBrandSettings };
}